import React from 'react';
import { Spinner, ErrorBox, EmptyState } from './UI';
import { useSeasons } from '../hooks/useApi';

export default function SeasonSelector({ competition, onSelect }) {
  const { seasons, loading, error } = useSeasons(competition?.competitionId);

  if (loading) return <Spinner label="Caricamento stagioni…" />;
  if (error) return <ErrorBox message={`Impossibile caricare le stagioni: ${error}`} />;
  if (!seasons.length) return <EmptyState icon="📅" title="Nessuna stagione disponibile" />;

  // Sort seasons by name descending (most recent first)
  const sorted = [...seasons].sort((a, b) =>
    (b.seasonName || '').localeCompare(a.seasonName || '')
  );

  return (
    <section className="selector-section">
      <h2 className="section-title">
        Stagioni — <span className="section-sub">{competition.officialName || competition.name}</span>
      </h2>
      <div className="season-list">
        {sorted.map(season => (
          <button
            key={season.seasonId}
            className="season-item"
            onClick={() => onSelect(season)}
          >
            <span className="season-name">{season.seasonName}</span>
            <span className="season-arrow">→</span>
          </button>
        ))}
      </div>
    </section>
  );
}
